<template>
  <div class="reports-manager">
    <div class="header">
      <h2>Signalements</h2>
      <el-select v-model="statusFilter" placeholder="Filtrer par statut" clearable @change="loadReports">
        <el-option label="Tous" value="" />
        <el-option label="En attente" value="pending" />
        <el-option label="Examiné" value="reviewed" />
        <el-option label="Rejeté" value="dismissed" />
      </el-select>
    </div>

    <el-table :data="reports" v-loading="loading" stripe style="width: 100%">
      <el-table-column prop="created_at" label="Date" width="160">
        <template #default="{ row }">{{ formatDate(row.created_at) }}</template>
      </el-table-column>
      <el-table-column prop="reporter_name" label="Signalé par" width="160" />
      <el-table-column prop="reported_user_name" label="Utilisateur signalé" width="160" />
      <el-table-column prop="reason" label="Raison" width="180">
        <template #default="{ row }">{{ reasonLabel(row.reason) }}</template>
      </el-table-column>
      <el-table-column prop="details" label="Détails" min-width="200" show-overflow-tooltip />
      <el-table-column prop="status" label="Statut" width="120">
        <template #default="{ row }">
          <el-tag :type="statusType(row.status)">{{ statusLabel(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="200" fixed="right">
        <template #default="{ row }">
          <template v-if="row.status === 'pending'">
            <el-button size="small" type="success" @click="markReviewed(row)">Examiner</el-button>
            <el-button size="small" type="info" @click="dismiss(row)">Rejeter</el-button>
          </template>
          <span v-else class="text-muted">—</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { fetchReports, updateReportStatus } from '../services/adminApi'
import { ElMessage } from 'element-plus'

const reports = ref([])
const loading = ref(false)
const statusFilter = ref('')

const reasonLabels = {
  inappropriate_content: 'Contenu inapproprié',
  harassment: 'Harcèlement',
  fraud: 'Fraude',
  spam: 'Spam',
  other: 'Autre',
}

const reasonLabel = (r) => reasonLabels[r] || r
const statusLabel = (s) => ({ pending: 'En attente', reviewed: 'Examiné', dismissed: 'Rejeté' }[s] || s)
const statusType = (s) => ({ pending: 'warning', reviewed: 'success', dismissed: 'info' }[s] || '')

const formatDate = (iso) => {
  if (!iso) return ''
  const d = new Date(iso)
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

async function loadReports() {
  loading.value = true
  try {
    reports.value = await fetchReports(statusFilter.value)
  } catch (e) {
    ElMessage.error('Erreur lors du chargement des signalements')
  } finally {
    loading.value = false
  }
}

async function markReviewed(row) {
  await updateReportStatus(row.id, 'reviewed')
  row.status = 'reviewed'
  ElMessage.success('Signalement marqué comme examiné')
}

async function dismiss(row) {
  await updateReportStatus(row.id, 'dismissed')
  row.status = 'dismissed'
  ElMessage.success('Signalement rejeté')
}

onMounted(loadReports)
</script>

<style scoped>
.reports-manager { padding: 20px; }
.header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.header h2 { margin: 0; }
.text-muted { color: #999; }
</style>
